module.exports = __webpack_public_path__ + "assets/img/block-left-hover-dd91f31a.png";